<!-- 连连 变更银行卡申请 -->
<template>
  <el-dialog title="变更银行卡申请" :visible="visible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="onClose" v-loading="loading" append-to-body>
    <el-form ref="formRef" :model="formData" label-width="auto">
      <el-button @click="getVCode">填写连连密码,并提交审核</el-button>
      <el-form-item v-if="needVerify && changeBankCardRecordId" label="短信验证码" prop="verifyCode">
        <el-input class="margin-top-sm" v-model="formData.verifyCode" placeholder="请输入" />
        <div class="margin-top-sm">ps:短信验证码会发生到银行预留手机号,验证码有效期为30分钟</div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">关 闭</el-button>
      <el-button v-if="needVerify && changeBankCardRecordId" @click="submitCode">提交验证码</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GetApplyPasswordElement, ChangeBankCardApply,ChangeBankCardVerify } from '@/api'
export default {
  name: "LLpayWithdrawConfirmDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      loading: false,
      shop: {},
      formData: {
        password: undefined,
        randomKey: undefined,
        token: undefined,
        verifyCode: undefined,
        txnSeqno: undefined,
      },
      sendVerifyCodeTiemOut: 0,
      withdrawChannel: "llpay",
      needVerify: false,
      changeBankCardRecordId: undefined,
    }
  },
  methods: {
   
    onSuccess(){
      this.$emit("success")
    },
    onClose() {
      this.visible = false
      this.formData = {
        password: undefined,
        randomKey: undefined,
        token: undefined,
        verifyCode: undefined,
        txnSeqno: undefined,
      }
      this.needVerify = false
      this.changeBankCardRecordId = undefined
      this.$emit("close")
    },
    open(data) {
      this.visible = true
      this.data = {...data}
      this.data.shopId =  this.data.userId
    },
    submitCode(){
      if(!this.formData.verifyCode){
        this.$message.error("请填写验证码")
        return
      }
      this.loading = true
      ChangeBankCardVerify({
        changeBankCardRecordId: this.changeBankCardRecordId,
        verifyCode: this.formData.verifyCode
      }).then(res=>{
        if(res){
          this.$message.info("提交成功，等待第三方处理")
          this.onClose()
          this.onSuccess()
        }
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    getVCode() {
      // 输入密码
      const pwdScene = "bind_card_password"
      GetApplyPasswordElement({ shopId: this.data.shopId, pwdScene: pwdScene, flagChnl: "PCH5" }).then(res => {
        window.lianlianpay.invokePasswordControl(
          {
            // 使用场景
            passwordScene: pwdScene,
            // 商户号
            oidPartner: res.mch_id,
            // 用户号
            userId: 'SHOP_' + this.data.shopId,
            // token
            passwordElementToken: res.password_element_token,
            // 环境 ste-测试环境 production-生产环境
            env: 'production',
            // 终端类型 默认根据设备自适应 H5-移动端 PC-桌面端
            terminal: '',
            // 样式配置
            styles: {
              themeColor: '#667eea'
            }
          },
          (res) => {
            console.log('密码数据', res)
            if (res.data.password) {
              // 提交银行变更审核
              ChangeBankCardApply({ ...this.data, password: res.data.password, randomKey: res.data.randomKey }).then(res => {
                if(!res){
                  this.$message.success("提交失败")
                  return
                }
                if (res.needVerify) {
                  // 进行短信验证
                  this.$message.success("提交成功，需要进行短信验证码验证！")
                  this.needVerify = res.needVerify
                  this.changeBankCardRecordId =  res.changeBankCardRecordId
                  // const it = setInterval(() => {
                  //   if (this.sendVerifyCodeTiemOut > 0) {
                  //     this.sendVerifyCodeTiemOut = this.sendVerifyCodeTiemOut - 1
                  //   } else {
                  //     clearInterval(it)
                  //   }
                  // }, 1000)
                } else  {
                  this.$message.success("提交成功，等待第三方处理")
                  this.onClose()
                  this.onSuccess()
                }

              })
            } else {
              this.$message.success("密码输入异常")
            }
            // this.formData.password = res.data.password
            // this.formData.randomKey = res.data.randomKey

          }
        )
      })
      // OpenacctActivateApply({shopId:this.shop.id,password:this.formData.password,randomKey:this.formData.randomKey}).then(res=>{
      //   this.formData.token = res.token
      //   this.formData.txnSeqno = res.txn_seqno
      //   this.$message.success("短信发送成功")
      // })
    },


  }
};
</script>

<style lang="scss" scoped>
.meta-top {
  color: #909399;
  font-size: 12px;
  margin-bottom: 8px;
}

.meta-top>span+span {
  margin-left: 20px;
}

.block {
  border: 1px solid var(--color-border, #ebeef5);
  border-radius: 8px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0;
  border: 1px solid #ebeef5;
  border-bottom: none;
}

::v-deep .el-card .el-card__header {
  padding: 14px 15px 7px;
  min-height: 40px;
  background: #fafafa;
}
</style>
